import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Public hook: reads the `coming_soon` feature flag without requiring auth.
 * Uses the public `platform-settings` edge function so anonymous callers
 * never need direct read access on the `feature_flags` table.
 */
export function useComingSoon() {
  const { data, isLoading } = useQuery({
    queryKey: ["coming_soon_flag"],
    queryFn: async () => {
      try {
        const { data, error } = await supabase.functions.invoke("platform-settings", { method: "GET" });
        if (error) throw error;
        const flag = (data as any)?.__feature_flags?.coming_soon;
        return !!flag?.enabled_global;
      } catch (err) {
        console.warn("coming_soon flag read failed:", (err as Error)?.message);
        return false;
      }
    },
    staleTime: 1000 * 60,
  });

  return {
    comingSoon: !!data,
    loading: isLoading,
  };
}
